import React from 'react';

const BusinessUnitConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/organizationalsetup/clientjobstatus',
			component:React.lazy(() => import('./ClientJobStatus')) 
        }
	]
};

export default BusinessUnitConfig;